import { DepartmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useArchiveDepartMent = () =>
  useMutationWithLoading(
    async (param: { depId: string; status: boolean; xTENANTID?: string }) =>
      new DepartmentControllerApi(
        getConfigObject()
      ).updateDepartmentArchiveStatus(
        param.depId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
